/**
 * Nupsu Sõprusklubi Landing Page Form Handler
 */
(function() {
    'use strict';

    let childCounter = 1;

    /**
     * Add a new child entry to the form
     */
    function addChildEntry() {
        childCounter++;
        const container = document.getElementById('soprusklubi-landing-children-container');
        if (!container) return;

        const entry = document.createElement('div');
        entry.className = 'soprusklubi-child-entry';
        entry.dataset.childIndex = childCounter;
        entry.innerHTML = `
            <button type="button" class="soprusklubi-remove-child" aria-label="Eemalda laps">&times;</button>
            <div class="soprusklubi-child-fields">
                <div class="soprusklubi-form-group">
                    <label for="soprusklubi-landing-child-name-${childCounter}">Lapse eesnimi</label>
                    <input type="text" id="soprusklubi-landing-child-name-${childCounter}" name="children[${childCounter}][name]" placeholder="Eesnimi">
                </div>
                <div class="soprusklubi-form-group">
                    <label for="soprusklubi-landing-child-month-${childCounter}">Sünnikuu</label>
                    <select id="soprusklubi-landing-child-month-${childCounter}" name="children[${childCounter}][birth_month]">
                        <option value="">Vali kuu</option>
                        <option value="1">Jaanuar</option>
                        <option value="2">Veebruar</option>
                        <option value="3">Märts</option>
                        <option value="4">Aprill</option>
                        <option value="5">Mai</option>
                        <option value="6">Juuni</option>
                        <option value="7">Juuli</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">Oktoober</option>
                        <option value="11">November</option>
                        <option value="12">Detsember</option>
                    </select>
                </div>
            </div>
        `;

        container.appendChild(entry);

        // Attach remove handler
        entry.querySelector('.soprusklubi-remove-child').addEventListener('click', function() {
            entry.remove();
        });
    }

    /**
     * Collect form data
     */
    function collectFormData() {
        const form = document.getElementById('soprusklubi-landing-form');
        if (!form) return null;

        const consentCheckbox = form.querySelector('input[name="newsletter_consent"]');
        const emailInput = form.querySelector('input[name="email"]');
        const parentNameInput = form.querySelector('input[name="parent_name"]');

        const data = {
            action: 'nupsu_register_soprusklubi',
            nonce: nupsu_soprusklubi_landing.nonce,
            newsletter_consent: consentCheckbox && consentCheckbox.checked ? 1 : 0,
            email: emailInput ? emailInput.value.trim() : '',
            parent_name: parentNameInput ? parentNameInput.value.trim() : '',
            children: []
        };

        // Collect children data
        const childEntries = form.querySelectorAll('.soprusklubi-child-entry');
        childEntries.forEach(function(entry) {
            const nameInput = entry.querySelector('input[type="text"]');
            const monthSelect = entry.querySelector('select');

            const childName = nameInput ? nameInput.value.trim() : '';
            const birthMonth = monthSelect ? monthSelect.value : '';

            if (childName) {
                data.children.push({
                    name: childName,
                    birth_month: birthMonth
                });
            }
        });

        return data;
    }

    /**
     * Show status message
     */
    function showStatus(message, type) {
        const statusEl = document.getElementById('soprusklubi-landing-status');
        if (!statusEl) return;

        statusEl.textContent = message;
        statusEl.className = 'soprusklubi-status ' + type;
        statusEl.style.display = 'block';

        // Scroll status into view
        statusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /**
     * Hide status message
     */
    function hideStatus() {
        const statusEl = document.getElementById('soprusklubi-landing-status');
        if (statusEl) {
            statusEl.style.display = 'none';
        }
    }

    /**
     * Handle form submission
     */
    function handleSubmit(e) {
        e.preventDefault();
        hideStatus();

        const data = collectFormData();
        if (!data) return;

        // Validation
        if (!data.newsletter_consent) {
            showStatus('Palun kinnita, et soovid liituda Nupsu Sõprusklubiga.', 'error');
            return;
        }

        if (!data.email) {
            showStatus('Palun sisesta e-posti aadress.', 'error');
            return;
        }

        if (!data.parent_name) {
            showStatus('Palun sisesta lapsevanema nimi.', 'error');
            return;
        }

        if (data.children.length === 0) {
            showStatus('Palun sisesta vähemalt ühe lapse nimi.', 'error');
            return;
        }

        // Disable submit button
        const submitBtn = document.getElementById('soprusklubi-landing-submit');
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Saadan...';
        }

        // Send AJAX request
        const formData = new FormData();
        formData.append('action', data.action);
        formData.append('nonce', data.nonce);
        formData.append('newsletter_consent', data.newsletter_consent);
        formData.append('email', data.email);
        formData.append('parent_name', data.parent_name);
        formData.append('children', JSON.stringify(data.children));

        fetch(nupsu_soprusklubi_landing.ajax_url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
        .then(function(response) {
            return response.json();
        })
        .then(function(result) {
            if (result.success) {
                showStatus(result.data.message, 'success');
                // Mark user as subscribed - never show popup again
                localStorage.setItem('nupsu_soprusklubi_subscribed', '1');
                // Hide form after success
                const formEl = document.getElementById('soprusklubi-landing-form');
                if (formEl) {
                    formEl.style.display = 'none';
                }
            } else {
                // Handle duplicate email error with specific message
                let errorMessage = result.data.message || 'Tekkis viga. Palun proovi uuesti.';
                if (errorMessage.includes('juba registreeritud')) {
                    errorMessage = 'See e-posti aadress on juba registreeritud. Kui soovid oma andmeid uuendada, palun võta meiega ühendust.';
                }
                showStatus(errorMessage, 'error');
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Liitu Sõprusklubiga';
                }
            }
        })
        .catch(function(error) {
            console.error('Soprusklubi error:', error);
            showStatus('Tekkis viga. Palun proovi uuesti.', 'error');
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = 'Liitu Sõprusklubiga';
            }
        });
    }

    /**
     * Initialize form
     */
    function init() {
        const form = document.getElementById('soprusklubi-landing-form');
        const addChildBtn = document.getElementById('soprusklubi-landing-add-child');

        if (!form) return;

        // Form submission
        form.addEventListener('submit', handleSubmit);

        // Add child button
        if (addChildBtn) {
            addChildBtn.addEventListener('click', addChildEntry);
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
